module.exports = __webpack_public_path__ + "img/logo.f27c51a.png";